/**
 * Разбор ответа DELETE /api/v2/executors/{id}.
 * @param {{ executor_id?: number, deleted?: boolean } | null | undefined} payload
 * @returns {{ ok: boolean, message: string }}
 */
export function resolveDeleteExecutorResult(payload) {
  if (!payload || typeof payload !== 'object') {
    return {
      ok: false,
      message: 'Не удалось удалить исполнителя',
    }
  }

  if (payload.deleted === false) {
    return {
      ok: false,
      message: 'У пользователя недостаточно прав для удаления',
    }
  }

  if (payload.deleted === true) {
    return {
      ok: true,
      message: 'Исполнитель удалён',
    }
  }

  return {
    ok: false,
    message: 'Не удалось удалить исполнителя',
  }
}
